<div class="flex-container gap-8" style="height: 100%">
  <vl-widget-title [text]="'dashboard_ui.ofs_en_attente' | trans" [widget]="widget()" [draggable]="true">
    <ng-content class="drag-handler" select='.drag-handler'></ng-content>
  </vl-widget-title>

  <div class="flex-row gap-8 p-4 border-box shrink-0 wrap">
    <vl-chips [bubble]="countPlanif()"
              [contentHeight]="true"
              size="small"
              [state]="subType() === widgetSubType.OF_ATTENTE_PLANIF ? 'active' : 'enabled'"
              (action)="subType.set(widgetSubType.OF_ATTENTE_PLANIF)">
      {{ 'dashboard_ui.of_planif' | trans }}
    </vl-chips>
    <vl-chips [bubble]="countProd()"
              [contentHeight]="true"
              size="small"
              [state]="subType() === widgetSubType.OF_ATTENTE_PROD ? 'active' : 'enabled'"
              (action)="subType.set(widgetSubType.OF_ATTENTE_PROD)">
      {{ 'dashboard_ui.of_prod' | trans }}
    </vl-chips>
    <vl-chips [bubble]="countEnProd()"
              [contentHeight]="true"
              size="small"
              [state]="subType() === widgetSubType.OF_EN_PROD ? 'active' : 'enabled'"
              (action)="subType.set(widgetSubType.OF_EN_PROD)">
      {{ 'dashboard_ui.of_en_prod' | trans }}
    </vl-chips>
    <vl-chips [bubble]="countReinte()"
              [contentHeight]="true"
              size="small"
              [state]="subType() === widgetSubType.OF_ATTENTE_REINTEGRATION ? 'active' : 'enabled'"
              (action)="subType.set(widgetSubType.OF_ATTENTE_REINTEGRATION)">
      {{ 'dashboard_ui.of_reintegration' | trans }}
    </vl-chips>
    <vl-chips [bubble]="countValidation()"
              [contentHeight]="true"
              size="small"
              [state]="subType() === widgetSubType.OF_ATTENTE_VALIDATION ? 'active' : 'enabled'"
              (action)="subType.set(widgetSubType.OF_ATTENTE_VALIDATION)">
      {{ 'dashboard_ui.of_validation' | trans }}
    </vl-chips>
  </div>

  @if (metadata().loading) {
    <div class="grow overflow-hidden">
      <ngx-skeleton-loader count="10" [theme]="{'background-color': 'var(--color-on-disabled)'}"/>
    </div>
  } @else {
    <div class="grow list-area">
      <div class="overflow-scroll h100 flex-col gap-4 fade-in">
        @for (elem of ofs(); track elem.id) {
          <div class="flex-row align-center gap-8 p-8 border-on-disabled border-box border-8 cursor-pointer"
               (click)="onSelect(elem)">
            <div class="flex-col gap-2 grow overflow-hidden">
              <div class="flex-row gap-8 align-center">
                <span class="body-2 on-background-alt">{{ elem.numero }}</span>
                <span class="caption on-disabled shrink-0">{{ elem.ligne?.denomination }}</span>
              </div>
              <span class="tiny on-disabled" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{ elem.articleInfos?.denomination }}</span>
            </div>
            <mat-icon class="on-accent shrink-0">arrow_forward</mat-icon>
          </div>
        } @empty {
          <span class="caption on-disabled">{{ 'list.empty' | trans }}</span>
        }
      </div>

      @if (totalCount() > 0) {
        <vl-chips class="see-all-chip"
                  state="active"
                  size="small"
                  iconRight="open_in_new"
                  (action)="onSeeAll()"
                  matTooltip="Liste complète des OFs en attente avec recherche, tri et export Excel">
          {{ 'button.see_all' | trans }}
        </vl-chips>
      }
    </div>
  }
</div>
